<sc-modal [isOpen]="shouldDisplay" size="small">
  <div class="container text-center">
      <div class="row">
          <div class="col-md-12 col-12">
              <img class="supported-browser-img" src="assets/images/chrome.svg" alt="Chrome">
          </div>
          <div class="col-md-12 col-12">
              <sc-title type="h3" class="py-1" content="Parece que estás usando un navegador no soportado"></sc-title>
              <p class="caption my-0">Los navegadores no soportados pueden exponer tu computadora a riesgos de seguridad.</p>
              <p class="caption my-0 pb-2">Para tener una mejor experiencia, te recomendamos descargar Chrome.</p>
          </div>
      </div>
  </div>
  <div class="row">
      <div class="col-sm-6 col-12 text-right">
          <sc-button (onClick)="openChromeDownloadPage()">Descargar Chrome</sc-button>
      </div>
      <div class="col-sm-6 col-12 text-left">
          <sc-button (onClick)="continue()" type="secondary">Continuar igual</sc-button>
      </div>
  </div>
</sc-modal>